var crypto = require("crypto-js");

const password = 'BwjEtb5RFef5Dfk#';

function decrypt (transitmessage: any) {

    if (!transitmessage || transitmessage === '') 
        return undefined;

    var data =  transitmessage;
    let r2 = crypto.enc.Utf8.stringify(crypto.AES.decrypt(data, password));
    return r2;
}

export { decrypt, password }